<div [innerHTML]="module.settings.content.text | beePlaceholders | safeHtml"></div> 
